import React from 'react';
import useWizardFormCtx from '../ctx-provider/useWizardFormCtx';
import BtnNavNext from '../../../cmp/nav/BtnNavNext';
import useFormValidatorCtx from '../../../../form/ctx-provider/useFormValidatorCtx';
import FormValidatorCtxBo from '../../../../form/ctx-provider/FormValidatorCtxBo';

type Param = {
    disabled?: boolean
}

const PageButtonNext: React.FC<Param> = ({ disabled = false }) => {
    const { handleNextPage } = useWizardFormCtx();
    const { fireFormValidatorCtxBo } = useFormValidatorCtx();

    const doOnSumbitButton = (error: boolean) => {
        if (error === false) {
            handleNextPage();
        }
    }

    // doOnSumbitButton wird registriert.        
    const onSubmitButton = () => {
        FormValidatorCtxBo.doOnSubmitButton = doOnSumbitButton;
        fireFormValidatorCtxBo();
    }

    return <BtnNavNext onSubmit={onSubmitButton} disabled={disabled} />
}

export default PageButtonNext;